import SocialList from "../quiz/SocialList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpotify } from "@fortawesome/free-brands-svg-icons";
import { fetchSpotifyArtists } from "shared/service/StrmService";
import { useTranslation } from "react-i18next";
import { Form } from "antd/lib";
import HeroIconSrc from "shared/assets/images/hero-icon.png";
import { HeroSteps } from "./Hero";
import { useEffect } from "react";
import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";

interface Props {
  setCurrentStep: any;
}
const hasURL = (value: string) => value.includes("http") || value.includes("/");

const HeroStep: React.FC<Props> = ({ setCurrentStep }) => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const spotify = Form.useWatch("spotify", form);

  const getSpotifyArtists = async (term: string, offset: number = 0) => {
    if (term) {
      if (hasURL(term)) {
        return [];
      } else {
        const artists: any = await fetchSpotifyArtists(
          term,
          "BR", //check rule
          offset
        );
        const artistsOption = artists.map(({ name, id, ...artist }: any) => ({
          name,
          id,
          avatarUrl: artist?.images[0]?.url,
        }));
        if (artistsOption.length === 0) {
          return [
            {
              name: t("quiz.pages.Questionario.spotifyNotFound"),
            },
          ];
        } else return artistsOption;
      }
    } else {
      return [];
    }
  };

  useEffect(() => {
    dataLayerViewedEvent({
      ...tagManagerEvent.Hero.S4A_HERO,
    });
  }, []);

  return (
    <div className="start full-height">
      <div
        className="background-default"
        style={{
          backgroundImage: `url(${HeroIconSrc})`,
        }}
      >
        <div style={{ padding: "0 40px" }}>
          <h1>{t("pages.StrmHero.heroTitle")}</h1>
          <Form.Item name="spotify">
            <SocialList
              label="Spotify"
              logo={<FontAwesomeIcon icon={faSpotify} className="label-icon" />}
              placeholder={t("quiz.pages.Questionario.searchPlaceholder")}
              getListOptions={getSpotifyArtists}
              showMore
              showDefaultImage={false}
              offsetTop={-64}
              bottomDefault={44}
            />
          </Form.Item>
        </div>
      </div>
      <div className="footer">
        <button
          className="botao-roxo"
          onClick={() => setCurrentStep(HeroSteps.Details)}
          type="button"
          disabled={!spotify}
          style={{ width: "100%" }}
        >
          {t("pages.StrmHero.continue")}
        </button>
      </div>
    </div>
  );
};

export default HeroStep;
